<div class="step-header">
	<div class="visible-md visible-lg visible-xl">
		<cng-progress-bar-static
			[is_header]="true"
			[current_step_key]="current_step_key"
			[location]="location + '_step_header'"
			(page_jump)="jumpTo($event)"
		></cng-progress-bar-static>
	</div>
	<div class="hidden-md hidden-lg hidden-xl container mobile-menu">
		<!--  CURRENT STEP -->

		<div class="step-container">
			<div class="arrowhead"></div>
			<p class="text">
				<span *ngIf="!menu_open">
					{{steps[current_step_key].name}}
					<span *ngIf="steps[current_step_key].minutes_to_complete">
						approx. {{steps[current_step_key].minutes_to_complete | pluralise:'minute':'+s'}}
					</span>
				</span>
				<span *ngIf="menu_open">JUMP TO STEP...</span>

			</p>
		</div>
		<div class="header-buttons-container">
			<!-- END CURRENT STEP -->

			<!--  ACTION ICONS  -->

			<ui-popover-with-menu [location]="'engage_configure_step_header'"></ui-popover-with-menu>

			<!-- END ACTION ICONS -->

			<!--  STEPS MENU  -->

			<div class="menu">
				<div
					class="menu-icon"
					[ngClass]="{ active: menu_open }"
					[tooltip]="menu_open ? 'Close Menu' : 'Open Menu'"
					[placement]="'bottom'"
					[attr.data-element-click]="
						'menu_icon__' + location + '_step_header__[' + (menu_open ? 'Close Menu' : 'Open Menu') + ']'
					"
					(click)="menu_open = !menu_open"
				>
					<span></span>
				</div>
				<div class="step-navigation-container" [ngClass]="{ '
				show': menu_open }">
					<div
						class="backdrop"
						[attr.data-element-click]="'menu_background__' + location + '_step_header__menu_background'"
						(click)="menu_open = false"
					></div>
					<div class="step-navigation">
						<ul>
							<li
								*ngFor="let s of steps_order; let index = index"
								[ngClass]="{
									'visited-step': index <= current_step_index,
									'current-step': index === current_step_index
								}"
								[attr.data-element-click]="
									'menu_item__' + location + 'step_header__[' + steps[s].name + ']'
								"
								(click)="jumpTo(s)"
							>
								<div class="bullet">
									<span><i class="icon-chevron-right"></i></span>
								</div>
								<span class="text">{{ steps[s].name }}</span>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<!--  END STEPS MENU  -->
		</div>
	</div>
</div>
